"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
namespace_1.default.namespace.extend('setup.device', {
    /*
        Checks if we use a touch device, checks if the device is a mobile device and sets the events.
        The params are set in the "global" attribute called apa.device which can be used everywhere inside of the namespace apa.
        Resolving the deferred afterwards to start the loading process of the packages.
    */
    check: function (deferred, userAgent) {
        if (!userAgent)
            userAgent = navigator.userAgent;
        var parser = new ua_parser_js_1.default(userAgent);
        var device = parser.getDevice();
        //device.type can be: console, mobile, tablet, smarttv, wearable, embedded
        if (userAgent.indexOf('Tablet PC') > -1 && userAgent.indexOf('Windows') > -1)
            device.type = undefined; // For those hybrid monster tablet pcs we all hate
        if (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
            device.type = 'tablet'; // For stupid ipad pros after 2018 who thinks they are an desktop - no ipad, you are just an asshole
        if (device.type == 'mobile' || device.type == 'tablet' || device.type == 'wearable') {
            namespace_1.default.device.isClick = true;
            namespace_1.default.device.startEvent = 'touchstart';
            namespace_1.default.device.holdEvent = 'taphold';
            namespace_1.default.device.moveEvent = 'touchmove';
            namespace_1.default.device.clickEvent = 'touchend';
            namespace_1.default.device.endEvent = 'touchend';
            namespace_1.default.device.scrollClickEvent = 'touchmove touchend';
            namespace_1.default.device.hasTouch = true;
            namespace_1.default.device.isMobile = device.type == 'mobile';
            (0, jquery_1.default)(document).on(namespace_1.default.device.scrollClickEvent, '.apaOuterFrame', function (ev) {
                if (ev.type == 'touchmove') {
                    namespace_1.default.device.isClick = false;
                }
                else if (ev.type == 'touchend') {
                    namespace_1.default.device.isClick = true;
                }
            });
        }
        else {
            namespace_1.default.device.isClick = true;
            namespace_1.default.device.startEvent = 'mousedown';
            namespace_1.default.device.holdEvent = 'mousedown';
            namespace_1.default.device.moveEvent = 'mousemove';
            namespace_1.default.device.clickEvent = 'click';
            namespace_1.default.device.endEvent = 'mouseup';
            namespace_1.default.device.scrollClickEvent = 'click';
            namespace_1.default.device.hasTouch = false;
            namespace_1.default.device.isMobile = false;
        }
        deferred.resolve();
    }
});
